import styled from "styled-components";
import AntBreadCrumbs from "uiKits/BreadCrums";
import AntButton from "uiKits/Button";
import { CONTENT_WIDTH, media } from "@/theme/breakpoints";

export const StyledBreadCrumbs = styled(AntBreadCrumbs)``;

export const MainContainer = styled.div`
  width: ${CONTENT_WIDTH.pct};
  max-width: 100%;
  margin: 0 auto;
  margin-top: 35px;
  box-sizing: border-box;
  padding: 0 16px;

  ${media.downTablet`
    margin-top: 24px;
  `}
`;

export const InnerContainer = styled.div`
  margin-top: 50px;
  border-top: 1px solid #d9d9d9;
  border-bottom: 1px solid #d9d9d9;

  ${media.downTablet`
    margin-top: 32px;
  `}
`;

export const StyledHeading = styled.h2`
  margin: 0px;
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${media.downMobile`
    font-size: 20px;
  `}
`;

export const CartFooter = styled.div`
  margin-top: 20px;
`;

export const EstimatedTimeWithIcon = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;

  ${media.downTablet`
    flex-direction: column;
    gap: 16px;
  `}
`;

export const TimeText = styled.p`
  margin: 0px;
  color: var(--Text2, #000);
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: 0.48px;
  width: 30%;

  ${media.downTablet`
    width: 100%;
  `}
`;

export const TotalWrapper = styled.div`
  width: 65%;
  text-align: right;

  ${media.downTablet`
    width: 100%;
    text-align: left;
  `}
`;

export const StyledTotal = styled.h2`
  margin: 0px;
  color: #000;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  text-align: right;

  ${media.downTablet`
    text-align: stretch;
  `}
`;

export const StyledButton = styled(AntButton)`
  font-size: 18px;
  min-height: 44px;
  height: 50px;
  padding: 4px 40px;
  border-radius: 4px;

  ${media.downMobile`
    width: 100%;
  `}
`;

export const EmptyCartWrapper = styled.div`
  margin-top: 180px;
  margin-bottom: 180px;
  text-align: center;

  ${media.downTablet`
    margin-top: 80px;
    margin-bottom: 80px;
  `}
`;

export const EmptyCartImage = styled.img`
  max-width: 100%;
  height: auto;
`;

export const EmptyCartText = styled.p`
  margin-top: 80px;
  color: var(--Text2, #000);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  ${media.downMobile`
    font-size: 20px;
    margin-top: 40px;
  `}
`;
